<template>
	<div class="post-content wrapper">
		<transition name="fadeIn" mode="out-in">
			<div :class="['post-content__container', getRouteLeave ? 'post--leave' : '']" v-if="dataReady" :key="dataReady">
				<div class="post-content__content" :style="{ maxWidth: contentData.acf.img_max_size ? `${contentData.acf.img_max_size}px` : '800px' }" v-if="contentData.content.rendered" v-html="contentData.content.rendered"></div>

				<div class="post-content__imgs" :style="{ maxWidth: contentData.acf.img_max_size ? `${contentData.acf.img_max_size}px` : '800px' }">
					<image-comp v-for="n in 10" v-if="contentData.acf[`img_project_${n}`]" :herited-data="contentData.acf[`img_project_${n}`]" key="img"></image-comp>
				</div>

				<footer-comp></footer-comp>
			</div>

			<div v-else class="loading-page" :key="dataReady">
				<loader :label="routeName"></loader>
			</div>
		</transition>
	</div>
</template>

<script>
	import { common } from '~components/common'
	import { ui } from '~components/ui'
	import contentMixin from '~mixins/ContentType'
	import _ from 'lodash'

	export default {
		name: 'post-type',
		mixins: [contentMixin],
		components: {
			common,
			ui
		},
		methods: {
			setMenu () {
				const cat = this.$store.getters.getCategoriesData
				const catPost = this.contentData.categories[0]

				const catSlug = _.find(cat, (el) => {
					return el.id === catPost
				})

				this.$store.commit('setPostCategory', catSlug.label)
			}
		},
		computed: {
			getRouteLeave () {
				return this.$store.getters.getRouteLeave
			}
		}
	}
</script>

<style lang="scss">
	.post-content__container {
		padding: 50px 0;
	}

	.post-content__content {
		margin: 0 auto 50px;

		p {
			letter-spacing: 0.05em;
			line-height: 1.5;
			@include fontSize(15);
		}

		img {
			max-width: 100%;
			height: auto !important;
		}

		iframe {
			width: 100%;
			height: 500px;

			@include mobile {
				height: 300px;
			}
		}
	}

	.post-content__imgs {
		max-width: 800px;
		margin: auto;

		img {
			display: block;
			margin: 0 auto 30px;
			max-width: 100%;
		}
	}

	.post-content__container {
		@include transition(all .4s);

		&.post--leave {
			opacity: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/vue/components/content-type/Post.vue?572e5785